import md5 from 'md5'
const SIGNKEY = 'sjdxfnqogbzoun13d971ckh8p'
import store from '@/store/index.js'
import { getRandomId } from '@/utils/index'

export function getSignHeader (param, isJsonContent) {
  let headers = {}
  let paramValStr = ''
  let timestamp = new Date().getTime()
  if (param && typeof param === 'object') {
    if (isJsonContent) {
      paramValStr = JSON.stringify(param)
    } else {
      Object.keys(param).sort().forEach((item) => {
        paramValStr += param[item]
      })
    }
  }
  let signature = md5(`${SIGNKEY}${paramValStr}${timestamp}`)
  headers.signature = signature
  headers.timestamp = timestamp
  headers.appcode = store.state.serviceConfig.appCode || ''
  return headers
}

export function getCommonHeaders (params, options) {
  let valueArr = [], sParams = '';
  if (params) {
    if (options && options.json) {
      sParams = JSON.stringify(params);
    } else {
      const sortedObjKeys = Object.keys(params).sort()
      for (let index in sortedObjKeys) {
        if(sortedObjKeys.hasOwnProperty(index)) {
          valueArr.push(params[sortedObjKeys[index]])
        }
      }
      sParams = valueArr.join('');
    }
  }
  let signStr = btoa(decodeURI(decodeURI('%257D%25C3%25B7w%25C3%2593%25C2%25AE%251Bq%25C3%25BE%255E%25C3%25A3M%25C2%25B9m%25C2%25A7%25C2%25BC%25C3%259FM6s%25C2%259F%257B%25C3%2599%25C3%2597y')))
  let appCode = 'com.rjhy.uranus'
  let timestamp = new Date().getTime()
  const sign = md5(signStr + sParams + timestamp)
  let headers = {
    signature: sign,
    timestamp: timestamp,
    appcode: appCode,
    clienttype: 'h5',
    serverId: 200
  }
  return headers
}

export function createNewGatwaySign(params, method, isJson) {
    const appCode = 'com.rjhy.uranus';
    let valueArr;
    let timestamp;
    const signStr = btoa(decodeURI(decodeURI('%257D%25C3%25AE%25C2%259Ao~%25C3%259E%25C3%25A1%25C3%25B7:%25C3%25A3%25C2%2587uk%255D%257Cu%25C3%2597%25C3%259F%25C3%25A7%25C2%258E%25C3%25BD%25C3%259FO7')));
    let sign;
    if (params) {
      if (typeof params === 'object') {
        if (isJson || method === 'get') {
          valueArr = []
          const sortedObjKeys = Object.keys(params).sort()
          for (let index in sortedObjKeys) {
            if(sortedObjKeys.hasOwnProperty(index)) {
              valueArr.push(params[sortedObjKeys[index]])
            }
          }
          timestamp = new Date().getTime()
          sign = md5(signStr + valueArr.join('') + timestamp)
        } else {
          timestamp = new Date().getTime()
          sign = md5(signStr + JSON.stringify(params) + timestamp)
        }
      } else {
        valueArr = params
        timestamp = new Date().getTime()
        sign = md5(signStr + valueArr + timestamp)
      }
    }
    let headers = {
      signature: sign,
      timestamp: timestamp,
      appcode: appCode,
      clienttype: 'h5',
      requestId: getRandomId(),
    }
    return headers
}

export function createNewGatwaySignWx(params, method) {
    const appCode = 'com.rjhy.uranus';
    let valueArr;
    let signature;
    let timestamp;
    const signStr = btoa(decodeURI(decodeURI('%257D%25C3%25B7w%25C3%2593%25C2%25AE%251Bq%25C3%25BE%255E%25C3%25A3M%25C2%25B9m%25C2%25A7%25C2%25BC%25C3%259FM6s%25C2%259F%257B%25C3%2599%25C3%2597y')));
    if (method === 'post') {
        timestamp = new Date().getTime();
        signature = md5(signStr + JSON.stringify(params) + timestamp);
    } else {
        valueArr = [];
        const sortedObjKeys = Object.keys(params).sort();
        for (const index in sortedObjKeys) {
          if(sortedObjKeys.hasOwnProperty(index)) {
            valueArr.push(params[sortedObjKeys[index]]);
          }
        }
        timestamp = new Date().getTime();
        signature = md5(signStr + valueArr.join('') + timestamp);
    }
    return {
        signature,
        timestamp,
        appCode,
        requestId: getRandomId(),
    };
}
